import React from 'react';
import styled from 'styled-components';
import puzzleCityGridImage from '../assets/grid.svg';
import puzzleCityscapeImage from '../assets/cityscape.svg';
import heroDImage from '../assets/hero-d.svg';
import heroHImage from '../assets/hero-h.svg';
import { LightBeam } from './LightBeam';

const Container = styled.div`
  position: relative;
  display: block;
  box-sizing: border-box;

  /* 
  Padding percentages are in terms of width - 
  this padding enforces that this div remains square while
  still being responsive to width.
  */
  padding-top: 100%;
  pointer-events: none;
`;

const PuzzleCityGrid = styled.img`
  width: 100%;

  position: absolute;
  bottom: 0;
`;

const PuzzleCityscape = styled.img`
  width: 85%;

  position: absolute;
  bottom: 9%;
  left: 7.5%;
`;

const HeroD = styled.img`
  width: 30%;
  z-index: 2;

  position: absolute;
  left: 17%;
  //top: 15%;

  animation: levitate-d 1s alternate-reverse infinite;

  @keyframes levitate-d {
    0% {
      top: 15%;
    }
    100% {
      top: 14%;
    }
  }
`;

const HeroH = styled.img`
  width: 30%;
  z-index: 2;

  position: absolute;
  right: 23%;
  //top: 6%;

  animation: levitate-h 1s alternate-reverse infinite;
  animation-delay: 250ms;

  @keyframes levitate-h {
    0% {
      top: 6%;
    }
    100% {
      top: 5%;
    }
  }
`;

const LightBeamImage = styled(LightBeam)`
  position: absolute;
  left: -7.6%;
  top: -19%;
`;

export const HeroImage: React.FC = () => {
  return (
    <Container>
      <PuzzleCityGrid src={puzzleCityGridImage} alt="City grid made of puzzle pieces" />
      <PuzzleCityscape src={puzzleCityscapeImage} alt="Stylized cityscape" />
      <HeroD src={heroDImage} alt="D" />
      <HeroH src={heroHImage} alt="H" />
      <LightBeamImage />
    </Container>
  );
};
